import { TellentCurrentUser, TellentMember, TellentMemberRow } from '@core/tellent-types';

export function resolveMemberInitials(member: {
  firstName: string;
  lastName: string;
  email: string;
}) {
  const { firstName, lastName, email } = member;
  return firstName || lastName
    ? `${(firstName && firstName[0]) || ''}${lastName && lastName[0]}`
    : email![0];
}

export function resolveMemberFullName(
  member: Partial<TellentMember> | Partial<TellentMemberRow> | Partial<TellentCurrentUser>,
) {
  const { firstName, lastName, email } = member;
  return firstName || lastName ? `${firstName || ''} ${lastName || ''}` : email || '';
}
